import copyright from './copyright.vue'
export default copyright
